// The filter key names, these need to match the queryParam value specified from the API data on each of the filter options
export const QUERY_PARAM_SORT = 'sort';
export const QUERY_PARAM_PAGE = 'page';
